import React, { useEffect, useState } from "react";
import {
  apartmentImage1,
  bookingImage,
  calendarIcon,
  featureIcon,
  guestIcon,
  wosamPaystack,
} from "../assets";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import { apartments, bookingBgImages } from "../constants";
import { PaystackButton } from "react-paystack";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { set, useForm } from "react-hook-form";
import swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";

const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID_EVENTBOOKING;
const USER_ID = process.env.REACT_APP_USERID;

const BookingPage = () => {
  const [searchParams] = useSearchParams();
  const locationParam = searchParams.get("location") || "lagos"; // Default to Lagos if no param
  const { register, handleSubmit, setValue, getValues, reset } = useForm();
  const [dayDifference, setDayDifference] = useState(0);
  const [loading, setLoading] = useState(false);
  const [apartments, setApartments] = useState(null);
  const [current, setCurrent] = useState(0);
  const [location, setLocation] = useState(locationParam);

  useEffect(() => {
    setLocation(locationParam); // Update dropdown selection when param changes
  }, [locationParam]);

  function nextSlide() {
    setCurrent((prev) => (prev + 1) % bookingBgImages.length);
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleError = (errors) => {
    console.log(errors);
    // toast.error("Please fill in all fields");
  };

  function getDifferenceInDays(date1, date2) {
    // Get the difference in time (in milliseconds)
    const differenceInTime = date2.getTime() - date1.getTime();

    // Convert the time difference from milliseconds to days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    return differenceInDays;
  }

  const onSubmit = async (data) => {
    let apiKey;
    console.log(data);

    setStartDate(data.startDate);
    setEndDate(data.endDate);

    console.log("Button clicked");

    let start = new Date(data.startDate);
    let end = new Date(data.endDate);

    if (location === "lagos") {
      apiKey = "GST_CBX2jfpvF5lsYehRAtVFenmPv5a0UK4UInacuVoYwz4J";
    }
    if (location === "ogun") {
      apiKey = "WEB_NY8O93eEu8kz2vlVw9Ax1vgurMF0VUJbWbuGbcQRv0QS";
    }
    if (location === "abuja") {
      apiKey = "WEB_NY8O93eEu8kz2vlVw9Ax1vgurMF0VUJbWbuGbcQRv0QS";
    }

    try {
      if (!data.startDate || !data.endDate) {
        alert("Please fill in all inputs");
        // setIsLoading(false)
      } else {
        setLoading(true);
        const response = await fetch(
          "https://guestapi.roomability.io/Reservation/Availability",
          {
            method: "POST",
            headers: {
              "X-API-Key": apiKey,
              "content-type": "application/json",
              // "accept": "application/json"
            },
            body: JSON.stringify({
              checkInDate: data.startDate,
              checkOutDate: data.endDate,
              adultNo: "2",
              childNo: "1",
              facilityTypeId: 1,
            }),
          }
        );

        const newData = await response.json();

        console.log(newData);

        if (newData?.errorCode === 0) {
          setLoading(false);
          if (newData?.types.length === 0) {
            swal.fire({
              title: "Room not available, pick another date",
              icon: "error",
              toast: true,
              timer: 5000,
              position: "top-right",
              timerProgressBar: true,
              showConfirmButton: false,
            });
          }
          setApartments(newData?.types);
          console.log(newData?.errorMessage);
        } else {
          setLoading(false);
          console.log(newData?.errorMessage);
          swal.fire({
            title: newData?.errorMessage,
            icon: "error",
            toast: true,
            timer: 5000,
            position: "top-right",
            timerProgressBar: true,
            showConfirmButton: false,
          });
          // alert(newData?.errorMessage);
          setApartments([]);
        }

        handleShowApartments();
        setDayDifference(getDifferenceInDays(start, end));
        getDifferenceInDays(start, end);
      }
    } catch (err) {
      console.log(err);
      swal.fire({
        title: err,
        icon: "error",
        toast: true,
        timer: 5000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
      console.error(
        "Information cannot be retrived at the moment. Try again or Contact Support"
      );
      // Handle errors here
    }
  };

  const [showApartments, setShowApartments] = useState(false);
  const [checkOut, setCheckOut] = useState(1);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [userData, setUserData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSelectRoom = (id) => {
    const newSelectedRooms = apartments.filter((item) => {
      return item.roomTypeId === id;
    });
    if (!selectedRooms.includes(...newSelectedRooms)) {
      setSelectedRooms([...selectedRooms, ...newSelectedRooms]);
    }
  };

  const handleRemoveRoom = (id) => {
    const filteredRooms = selectedRooms.filter((item) => {
      return item.roomTypeId !== id;
    });
    setSelectedRooms([...filteredRooms]);
  };

  useEffect(() => {
    const sum = selectedRooms.reduce((accumulator, item) => {
      return accumulator + item.rate * dayDifference;
    }, 0);

    setTotalPrice(sum.toFixed(2));
  }, [selectedRooms]);

  const handleShowApartments = () => {
    setShowApartments(true);
  };

  const formatPrice = (price) => {
    return `₦${price.toFixed(2)}`;
  };

  const ifRoomSelected = (id) => {
    const room = selectedRooms.find((item) => {
      return item.roomTypeId === id;
    });
    return selectedRooms.includes(room);
  };
  // console.log(ifRoomSelected(1))

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    street: Yup.string().required("Street Address is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    pNumber: Yup.string().required("Phone Number is required"),
    address: Yup.string()
      .email("Invalid email address")
      .required("Email Address is required"),
  });

  const componentProps = {
    email: userData?.address,
    amount: totalPrice * 100,
    metadata: {
      name: userData?.firstName + " " + userData?.lastName,
      phone: userData?.pNumber,
    },
    publicKey: "pk_live_4c9e93d0c13efeb7aa2c92f31d1f7107a8ef6ef2",
    // publicKey: "pk_test_dsdfghuytfd2345678gvxxxxxxxxxx",
    text: "PROCEED TO PAYMENT",
    onSuccess: (reference) => {
      console.log("Payment Successful:", reference);
      setCheckOut(4);
    },
    onClose: () => {
      console.log("Payment closed");
    },
  };

  const reservations = selectedRooms?.map((item) => {
    return {
      roomTypeId: item.roomTypeId,
      checkInDate: startDate,
      checkOutDate: endDate,
      adultNo: "2",
      childNo: "1",
      arrivalTime: "2:00 PM",
      purpose: "Business",
      rate: item.rate,
      additionalReq: "",
      quantity: 1,
    };
  });

  console.log("reservations: ", reservations);

  const handleUserData = async (values) => {
    console.log(values);

    try {
      const response = await fetch(
        "https://guestapi.roomability.io/Reservation/Add",
        {
          method: "POST",
          headers: {
            "X-API-Key": "GST_CBX2jfpvF5lsYehRAtVFenmPv5a0UK4UInacuVoYwz4J",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            guest: {
              title: "",
              firstName: values.firstName,
              lastName: values.lastName,
              phone: values.pNumber,
              email: values.address,
              sex: "",
              occupation: "",
              countryId: 1,
              address1: values.street,
              address2: "",
              city: "",
              stateId: 1,
            },
            reservations: [...reservations],
            payment: {
              payTypeId: 1,
              payMethodId: 1,
              amount: totalPrice,
            },
          }),
        }
      );

      const newData2 = await response.json();
      console.log("newData2: ", newData2);

      if (newData2?.errorCode === 0) {
        // alert(newData2?.errorMessage);
        setUserData(values);

        const emailApartments = selectedRooms.map((item) => {
          return item.roomType;
        });
        console.log(emailApartments);

        const emailData = {
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.pNumber,
          email: values.address,
          street: values.street,
          totalPrice: totalPrice,
          apartments: emailApartments,
        };

        emailjs
          .send(SERVICE_ID, TEMPLATE_ID, emailData, USER_ID)
          .then((result) => {
            console.log("EmailJS result: ", result);
            swal.fire({
              title: "Reservations made Successfully",
              icon: "success",
              toast: true,
              timer: 5000,
              position: "top-right",
              timerProgressBar: true,
              showConfirmButton: false,
            });
          })
          .catch((err) => {
            console.error("EmailJS error: ", err);
            swal.fire({
              title: "Something went wrong. Try again",
              icon: "error",
              toast: true,
              timer: 5000,
              position: "top-right",
              timerProgressBar: true,
              showConfirmButton: false,
            });
          });

        setCheckOut((prev) => prev + 1);
      } else {
        alert(newData2?.errorMessage);
      }
    } catch (err) {
      console.error(err);
      alert(
        "Apartment cannot be reserved at the moment. Try again or Contact Support"
      );
    }
  };

  return (
    <div>
      {checkOut < 4 ? (
        <div
          className={`pt-32 pb-24 ${
            checkOut > 1 && "md:flex"
          } hidden justify-center items-center`}
        >
          <div className="flex flex-col items-center gap-1">
            <div className="relative flex items-center justify-center md:w-16 md:h-16 w-10 h-10 bg-[#FF9900] outline outline-[1px] outline-[#FF9900] text-white rounded-full font-bold">
              1
              <p className="absolute -bottom-8 w-[100px] -left-6 -right-6 text-black">
                Select Room
              </p>
            </div>
          </div>
          <div className="md:w-32 w-10 h-[2px] bg-[#B2B2B2]"></div>
          <div className="flex flex-col items-center gap-1">
            <div
              className={`relative flex items-center justify-center md:w-16 md:h-16 w-10 h-10 ${
                checkOut >= 2
                  ? "bg-[#FF9900] text-white outline outline-[1px] outline-[#FF9900]"
                  : "bg-transparent text-black outline outline-[1px] outline-black"
              }  text-black rounded-full font-bold`}
            >
              2
              <p className="absolute -bottom-8 w-[100px] -left-6 -right-6 text-black">
                Your Details
              </p>
            </div>
          </div>
          <div className="md:w-32 w-10 h-[2px] bg-[#B2B2B2]"></div>
          <div className="flex flex-col items-center gap-1">
            <div
              className={`relative flex items-center justify-center md:w-16 md:h-16 w-10 h-10 ${
                checkOut >= 3
                  ? "bg-[#FF9900] text-white outline outline-[1px] outline-[#FF9900]"
                  : "bg-transparent text-black outline outline-[1px] outline-black"
              } text-black rounded-full font-bold`}
            >
              3
              <p className="absolute -bottom-8 w-[100px] -left-1 -right-2 text-black">
                Payment
              </p>
            </div>
          </div>
          <div className="md:w-32 w-10 h-[2px] bg-[#B2B2B2]"></div>
          <div className="flex flex-col items-center gap-1">
            <div
              className={`relative flex items-center justify-center md:w-16 md:h-16 w-10 h-10 ${
                checkOut >= 4
                  ? "bg-[#FF9900] text-white outline outline-[1px] outline-[#FF9900]"
                  : "bg-transparent text-black outline outline-[1px] outline-black"
              } text-black rounded-full font-bold`}
            >
              4
              <p className="absolute -bottom-8 w-[100px] -left-1 -right-4 text-black">
                Complete
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center pt-32 md:pb-24 gap-2">
          <div className="flex flex-col items-center justify-center md:w-16 md:h-16 w-10 h-10 bg-[#00A859] outline outline-[1px] outline-[#00A859] text-white rounded-full font-bold">
            4
          </div>
          <p className="text-black">Booking Complete!</p>
        </div>
      )}

      {checkOut === 1 && (
        <div
          className={`${
            checkOut === 1 && "md:pt-24 pt-16 md:px-10 px-4 block"
          }`}
        >
          <div className="">
            <img
              src={bookingBgImages[current].imageUrl}
              alt=""
              className="md:h-[420px] h-[250px] w-full object-cover"
            />
          </div>
        </div>
      )}

      {checkOut === 1 && (
        <section
          className={`md:pt-0 pt-10 w-full flex md:flex-row flex-col md:gap-6 gap-2 mb-10 md:px-10 px-4`}
        >
          {/* <form
            className="flex md:flex-row flex-col md:items-center md:border border-[#919191] py-10 md:px-6 md:gap-0 gap-6 md:w-1/4 w-full"
          >
            <div className="flex md:justify-start items-center gap-4 w-full">
              <div className="">
                <p className="font-bold mb-1">Explore Apartments</p>
                <select
                  className="text-sm outline outline-none border border-white font-bold"
                >
                  <option value="">Ikeja Gra, Ikeja</option>
                  <option value="">Ogun</option>
                  <option value="">Abuja</option>
                </select>
              </div>
            </div>
            
          </form> */}
          <form
            id="form"
            onSubmit={handleSubmit(onSubmit, handleError)}
            className="flex md:flex-row flex-col md:items-center md:border border-[#919191] md:py-10 md:px-6 md:gap-0 gap-6 md:w-full"
          >
            <div className="flex md:justify-start items-center gap-4 w-full">
              <div className="">
                <p className="font-bold mb-1">Explore Apartments</p>
                <select
                  className="text-sm outline outline-none border border-white font-bold"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  // {...register("location")}
                >
                  <option value="lagos">Ikeja Gra, Ikeja</option>
                  <option value="ogun">Ogun</option>
                  <option value="abuja">Abuja</option>
                </select>
              </div>
            </div>
            <div className="flex md:justify-center items-center gap-4 w-full">
              <img src={calendarIcon} alt="" className="w-4 h-4" />
              <div className="">
                <p className="font-bold">Check In</p>
                <input
                  type="date"
                  id="startDate"
                  className="text-sm outline-none"
                  name="startDate"
                  {...register("startDate")}
                />
                {/* <span className="text-sm">15/02/24</span> */}
              </div>
            </div>
            <div className="flex md:justify-center items-center gap-4 w-full md:border-x border-[#919191]">
              <img src={calendarIcon} alt="" className="w-4 h-4" />
              <div className="">
                <p className="font-bold">Check Out</p>
                <input
                  type="date"
                  id="endDate"
                  className="text-sm outline-none"
                  name="endDate"
                  {...register("endDate")}
                />
                {/* <span className="text-sm">18/02/24</span> */}
              </div>
            </div>
            <div className="flex md:justify-center items-center gap-4 w-full">
              <img src={guestIcon} alt="" className="w-4 h-4" />
              <div className="">
                <p className="font-bold">Guests</p>
                <span className="text-sm">1-2 Guest(s)</span>
              </div>
            </div>
            <div className="flex justify-center items-center w-full">
              <button
                // onClick={handleShowApartments}
                className="md:py-3 py-2 md:px-10 text-white bg-[#00A859] outline-1 outline outline-[#00A859] rounded-sm font-bold text-sm w-full"
              >
                {loading ? "SEARCHING" : "SEARCH"}
              </button>
            </div>
          </form>
        </section>
      )}

      <main className=" flex md:flex-row flex-col w-full items-start gap-10 mb-10 md:px-10 px-4">
        {checkOut === 1 && (
          <section className="w-full flex flex-col gap-6">
            {showApartments && (
              <div className="flex flex-col gap-6">
                {apartments?.map((item) => (
                  <div
                    key={item.roomTypeId}
                    className="border border-[#919191] flex md:flex-row flex-col items-center md:gap-4 md:h-[230px]"
                  >
                    <img
                      src={item?.image1}
                      alt=""
                      className="md:w-[250px] w-full h-full"
                    />
                    <div className="py-4 md:pr-2 px-4">
                      <h2 className="text-lg font-bold">{item.roomType}</h2>
                      <p className="mt-1 mb-2 text-sm text-[#919191]">
                        Our One Bedroom Suite is perfect for solo travelers or
                        couples seeking a cozy and intimate setting. This suite
                        features a spacious living area, a fully equipped
                        kitchen, and a comfortable bedroom with a plush
                        king-sized bed.
                      </p>
                      <h2 className="text-lg font-bold mb-4">
                        {formatPrice(item.rate)}
                      </h2>
                      <button
                        onClick={() => handleSelectRoom(item.roomTypeId)}
                        className={`text-xs ${
                          ifRoomSelected(item.roomTypeId)
                            ? "bg-[#00A85920]"
                            : "bg-[#00A859] text-white"
                        } rounded-sm font-bold py-2 px-6 disabled:cursor-not-allowed`}
                        disabled={
                          ifRoomSelected(item.roomTypeId) ? true : false
                        }
                      >
                        SELECT ROOM
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        )}

        {checkOut === 2 && (
          <section className="md:w-4/5 w-full flex flex-col gap-6 md:pt-0 pt-24">
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                companyName: "",
                street: "",
                state: "",
                country: "",
                pNumber: "",
                address: "",
                notes: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleUserData(values);
              }}
            >
              {({ isSubmitting }) => (
                <Form id="form" className="flex flex-col gap-6">
                  <div className="flex md:flex-row flex-col w-full items-start justify-between gap-6">
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="firstName"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        First Name <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="firstName"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="lastName"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Last Name <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="lastName"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex md:flex-row flex-col w-full items-start justify-between gap-6">
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="companyName"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Company Name (Optional)
                      </label>
                      <Field
                        type="text"
                        name="companyName"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="street"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Street Address <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="street"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="street"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex md:flex-row flex-col w-full items-start justify-between gap-6">
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="state"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        State <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="state"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="country"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Country <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="country"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex md:flex-row flex-col w-full items-start justify-between gap-6">
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="pNumber"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Phone Number <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="pNumber"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="pNumber"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                      <label
                        htmlFor="address"
                        className="flex items-center gap-1 font-semibold text-sm"
                      >
                        Email Address <span className="text-red-500">*</span>
                      </label>
                      <Field
                        type="text"
                        name="address"
                        className="h-[50px] pl-4 border border-[#919191] rounded-md w-full outline-none"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 w-full">
                    <label
                      htmlFor="notes"
                      className="flex items-center gap-1 font-semibold text-sm"
                    >
                      Order Notes (Optional)
                    </label>
                    <Field
                      as="textarea"
                      name="notes"
                      className="h-[200px] pl-4 pt-4 border border-[#919191] rounded-md w-full outline-none resize-none"
                    />
                  </div>

                  <p className="font-semibold text-sm">
                    Your personal data will be used to process your order,
                    support your experiences throughout the website and other
                    purposes described in our privacy policies.
                  </p>

                  <button
                    type="submit"
                    className="text-xs bg-[#FF9900] text-white rounded-md font-bold h-[50px] px-6"
                    disabled={isSubmitting}
                  >
                    SUBMIT
                  </button>
                </Form>
              )}
            </Formik>
          </section>
        )}

        {checkOut === 3 && (
          <section className="md:w-4/5 w-full flex flex-col gap-6 md:pt-0 pt-10">
            <div className="h-[500px] w-full border border-[#919191] bg-black flex justify-center items-center text-center">
              {/* <h1 className="text-2xl md:w-[200px] w-full font-bold">
                PAYSTACK INTEGRATION
              </h1> */}
              <img src={wosamPaystack} alt="" className="h-[70px]" />
            </div>
            {/* <button
              onClick={() => setCheckOut((prev) => prev + 1)}
              className="text-xs bg-black text-white rounded-md font-bold h-[50px] px-6"
            >
              CONFIRM PAYMENT
            </button> */}
            <PaystackButton
              {...componentProps}
              className="text-xs bg-[#FF9900] text-white rounded-md font-bold h-[50px] px-6"
            />
          </section>
        )}

        {checkOut === 4 && (
          <section className="md:w-4/5 w-full flex flex-col gap-6">
            <div className="h-[100px] w-full border border-[#919191] flex justify-center items-center text-center">
              <p className="font-bold">
                A confirmation email has been sent to {userData?.address}
              </p>
            </div>
            <p className="text-sm">
              Thank you for booking, we look forward to welcoming you to our
              hotel soon, an in the mean time if you have any questions please
              do not hesitate to get in touvh with us via phone or email, we
              will be happy to hear from you.
            </p>
            <div className="flex items-center md:gap-10 gap-4">
              <p className="flex md:gap-4 gap-2">
                Check in Date:
                <b className="text-[#00A859]">{startDate}</b>
              </p>
              <p className="flex md:gap-4 gap-2">
                Check out Date/Time:
                <b className="text-[#FF9900]">{endDate} / 12:00pm</b>
              </p>
            </div>
            <div className="border border-[#919191] p-6">
              <div className="">
                <h2 className="font-bold text-xl mb-2">Need Assistance?</h2>

                <p className="font-medium text-sm">
                  Call: 09037629912 or 09037629913
                </p>
                <p className="font-medium text-sm">
                  Email: info@WosAmhotels.com
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <Link
                to="/apartments"
                className="text-xs bg-[#FF9900] text-white rounded-md font-bold h-[50px] px-6 flex justify-center items-center"
              >
                BOOK AGAIN
              </Link>
              <Link
                to="/"
                className="text-xs bg-transparent text-black border border-black rounded-md font-bold h-[50px] px-6 flex justify-center items-center"
              >
                GO HOME
              </Link>
            </div>
          </section>
        )}

        <section className="md:w-2/5 w-full flex flex-col gap-6">
          {selectedRooms.length > 0 && (
            <div className="border border-[#919191] md:p-6 p-4">
              <div className="">
                <h2 className="font-bold text-xl">Your Room(s)</h2>
                <div className="w-10 my-2 h-0.5 bg-black"></div>
                <p className="font-bold text-sm">
                  Dates: {startDate} - {endDate}
                </p>
                <p className="font-bold text-sm">
                  Guests: 1 Adult, 1 Child(ren)
                </p>
              </div>
              <div className="flex flex-col gap-4 mt-10 mb-0">
                {selectedRooms.map((item, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <img
                      src={item?.image1}
                      alt=""
                      className="w-[100px] h-[80px]"
                    />
                    <div className="flex flex-col gap-2 w-full">
                      <div className="flex justify-between gap-4 items-start">
                        <h2 className="text-sm font-semibold">
                          {item.roomType}
                        </h2>
                        <h2 className="text-sm font-bold">
                          {formatPrice(item.rate * dayDifference)}
                        </h2>
                      </div>
                      <div className="flex justify-between items-center">
                        <p className="text-sm underline text-gray-500">
                          {dayDifference} Nights
                        </p>
                        <button
                          onClick={() => handleRemoveRoom(item.roomTypeId)}
                          className={`text-xs font-bold text-red-500 ${
                            checkOut > 1
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          }`}
                          disabled={checkOut > 1 ? true : false}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {selectedRooms.length > 0 && (
                <div className="mt-6">
                  <div className="w-full mt-4 mb-6 h-[1px] bg-black"></div>
                  <div className="flex justify-between items-center mb-8">
                    <h2 className="text-xl font-bold">TOTAL</h2>
                    <h2 className="text-xl font-bold">{`₦${totalPrice}`}</h2>
                  </div>

                  <button
                    onClick={() => setCheckOut((prev) => prev + 1)}
                    className={`text-xs ${
                      checkOut >= 2
                        ? "bg-[#FF990020]"
                        : "bg-[#FF9900] text-white"
                    } font-bold py-4 w-full rounded-sm disabled:cursor-not-allowed`}
                    disabled={checkOut >= 2 ? true : false}
                  >
                    CONTINUE
                  </button>
                </div>
              )}
            </div>
          )}

          {checkOut > 1 && (
            <div className="border border-[#919191] md:p-6 p-6 w-full">
              <div className="">
                <h2 className="font-bold text-xl mb-2">Need Assistance?</h2>

                <p className="font-medium text-sm">
                  Call: 09028888883, 07074711608, 07074711610
                </p>
                <p className="font-medium text-sm">
                  Email: info@wosamapartments.com
                </p>
              </div>
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default BookingPage;
